import React from "react"

import './style.css'
/* eslint import/no-webpack-loader-syntax: off */
import SvgBgArrowPicked from "-!svg-react-loader!../../../icons/bg-arrows-picked.svg";
import SvgDecorRight from "-!svg-react-loader!../../../icons/decor-right.svg";
import SvgFrameLeftTop from "-!svg-react-loader!../../../icons/frame-left-top.svg";
import SvgFrameRightTopBold from "-!svg-react-loader!../../../icons/frame-right-top-bold.svg";
import SvgPickedIcon from "-!svg-react-loader!../../../icons/picked-icon-12.svg";
import SvgDecorLeftBottom from "-!svg-react-loader!../../../icons/decor-left-bottom.svg";
import SvgDecorBottomLeftBold from "-!svg-react-loader!../../../icons/decor-bottom-left-bold.svg";
import SvgArtPickedIcon from "-!svg-react-loader!../../../icons/art-picked-icon.svg";

export default function HandPicked({ container = '' } ) {
    return (
        <section className={`section hand-picked ${container}`}>
            <div className="main-container">
                <h2 className="hand-picked__title">Hand-picked art papers</h2>
                <p className="hand-picked__text">
                    We print on the latest Canon imagePROGRAF PRO-541, producing
                    exceptional results up to 44" in width.
                </p>
                <div className="hand-picked__icons">
                    <div className="hand-picked__box">
                        <SvgFrameLeftTop className="handle-piecked__decor--left-up"/>
                        <SvgArtPickedIcon className="hand-picked__icon"/>
                        <h4 className="hand-picked__box__title">
                            80 Years
                            <div>Long lasting</div>
                        </h4>
                        <SvgDecorBottomLeftBold className="handle-piecked__decor--rigth-down"/>
                    </div>
                    <div className="hand-picked__box hand-picked__box--wrap-second">
                        <SvgDecorLeftBottom className="hand-picked__decor--left-down"/>
                        <SvgPickedIcon className="hand-picked__icon"/>

                        <h4 className="hand-picked__box__title">12 Colours <div> Exceptional quality </div></h4>
                        <SvgFrameRightTopBold className="hand-picked__decor--right-up"/>
                    </div>
                    <div className="hand-picked__box hand-picked__box--wrap-third">
                        <SvgFrameLeftTop className="handle-piecked__decor--left-up"/>
                        <SvgBgArrowPicked className="hand-picked__icon"/>
                        <h4 className="hand-picked__box__title">
                            2400 x 1200 DPI
                            <div>Years Long lasting</div>
                        </h4>
                        <SvgDecorRight className="hand-picked__decor--right"/>
                    </div>
                </div>
            </div>
        </section>
    )
}


// WEBPACK FOOTER //
// ./src/new-components/templates/hand-picked/index.js